export const deleteItemFromLocalStorage = (key) => {
	if (localStorage.getItem(`${key}`)) {
		localStorage.removeItem(`${key}`);
	}
};
